import React from "react";
import { Cell } from "fixed-data-table-2";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  AssessmentData,
  EvidenceColumn,
  EvidenceColumnGroup,
  EvidenceType,
} from "../../../../../../../store/onboarding/types";
import FontAwesomeIconDropDown from "../drop-down/FontAwesomeIconDropDown";

import { Portal } from "react-portal";
import { evidenceColumnDisplayTitle } from "../Helpers";
import MeasurementLabelTooltip from "../MeasurementLabelTooltip";
import { Sorting } from "../../EvidenceTable";

type Props = {
  sortingDirection?: "asc" | "desc" | undefined;
  evidenceColumn: EvidenceColumn;
  evidenceColumnGroup: EvidenceColumnGroup;
  onBenchmarksView: (
    assessment: AssessmentData,
    selectedEvidenceColumnGroupId: number,
    selectedEvidenceColumn: EvidenceColumn,
    isBehaviorPrimary: boolean
  ) => any;
  onEvidenceSort: any;
  sorting: Sorting;
  isReadonly?: boolean;
  // onEvidenceSort: (
  //   evidence_column: EvidenceColumn,
  //   evidenceColumnGroupId: number
  // ) => any;
};

const MeasurementHeaderCell = (props: Props) => {

  const {
    evidenceColumn,
    evidenceColumnGroup,
    onBenchmarksView,
    onEvidenceSort,
    sortingDirection,
    sorting,
    isReadonly
  } = props;
  return (
    <Cell className="testLabel" >
      <div className="testLabelDropdown" style={{cursor:`${isReadonly ? 'default':''}`}}>
        <Dropdown>
          <Dropdown.Toggle
            as={FontAwesomeIconDropDown(
              <div className="testLabelName">
                <h5
                  className={
                    evidenceColumn.evidence_type === EvidenceType.NeedAreas ||
                      evidenceColumn.evidence_type === EvidenceType.DiagnosticInfo || 
                      evidenceColumn.evidence_type === EvidenceType.DiagnosticFollowUp
                      ? "contentAreasHeader"
                      : "contentAreasStandardHeader"
                  }
                >
                  <MeasurementLabelTooltip
                    evidenceColumn={evidenceColumn}
                    evidenceColumnGroup={evidenceColumnGroup}
                    sortingDirection={sortingDirection}
                    onEvidenceSort={onEvidenceSort}
                    sorting={sorting}
                    isReadonly={isReadonly}
                  />
                </h5>
              </div>
            )}
            id={"dropdownToggleEvidence"}
          />
          {evidenceColumn.evidence_type !== EvidenceType.BehaviorScreener 
          && evidenceColumn.evidence_type !== EvidenceType.NeedAreas
          && evidenceColumn.evidence_type !== EvidenceType.DiagnosticInfo
          && evidenceColumn.evidence_type !== EvidenceType.DiagnosticFollowUp
          && (<Portal>
            <Dropdown.Menu>
            <OverlayTrigger
                overlay={
                  <Tooltip id="fullName" className="customInfoTooltip">
                    <span>Sorting is based on the data rows currently displayed. Load more rows if needed.</span>
                  </Tooltip>
                }
              >
              <Dropdown.Item
                onClick={onEvidenceSort(evidenceColumn, evidenceColumnGroup)}
              >
                {(sorting.column == evidenceColumn.measurement?.column_name) && sorting.sortingCount == 2 ? `Click to reset`: `Sort by ${evidenceColumnDisplayTitle(evidenceColumn)}`}
              </Dropdown.Item>
            </OverlayTrigger>
              {evidenceColumn.evidence_type === EvidenceType.Data && (
                <Dropdown.Item
                  onClick={onBenchmarksView(
                    evidenceColumnGroup.assessment,
                    evidenceColumnGroup.id,
                    evidenceColumn,
                    evidenceColumnGroup.is_behaviour_primary_screening
                  )}
                >
                  View Benchmarks
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Portal>)}
        </Dropdown>
      </div>
    </Cell>
  );
};

export default MeasurementHeaderCell;
